module.exports = __webpack_public_path__ + "img/receipt.874bf68e.svg";